import React from 'react'
import { Helmet } from 'react-helmet-async'
import './WebDevelopmentSerivce.css'
import HeroWds from './HeroWds/HeroWds'
import Transform from './Transform/Transform'
import Testimonials from './Testimonials/Testimonials'
import Core from './Core/Core'
import Top from './Top/Top'
import Services from './services/Services';
import Why from './Why/Why'
function WebDevelopmentSerivce() {
    return (
        <div id='wds'>
            <Helmet>
                <title>Web Development Services | Custom Website Solutions</title>
                <meta name="description" content="Professional web development services building custom, scalable websites. From e-commerce to enterprise web solutions tailored for growth." />
                <link rel="canonical" href="https://bastionex.net/website-development" />
            </Helmet>
            <HeroWds/>
            <Transform/>
            <Why/>
            <Core/>
            <Top/>
            <Testimonials/> 
             <Services/>
        </div>
    )
}

export default WebDevelopmentSerivce